import { transformByMap } from '../../../utils/transformByMap.ts';

// Transforms frequency capping data for GraphQL mutation
export const transformFrequencyCapping = <T extends Record<string, unknown> = Record<string, unknown>>(
  frequencyCapping: Record<string, unknown> | Record<string, unknown>[] | null | undefined
): T | T[] | null | undefined => {
  return transformByMap(frequencyCapping, {
    time_period_value: 'int',
    impressions_limit: 'string',
  }) as T | T[] | null | undefined;
};
